import './ckeditor-base-path';
import 'ckeditor4';
